export default {
  getTags: state => state.tags,
  getUras: state => state.uras,
  getFilas: state => state.filas,
  getRegex: state => state.regex,
  getRotas: state => state.rotas,
  getAudios: state => state.audios,
  getTroncos: state => state.troncos,
  getWebhooks: state => state.webhooks,
  getConferencias: state => state.conferencias,
  getCentroDeCustos: state => state.centroDeCustos,
  getMusicasEmEspera: state => state.musicasEmEspera,
  getGruposAtendimento: state => state.gruposAtendimento,
  getAvaliacoesAtendimento: state => state.avaliacoesAtendimento,
}
